// extracted by mini-css-extract-plugin
export var bellring = "Y_c7";
export var boxErrorContainer = "Y_c2";
export var boxErrorWrapper = "Y_c6";
export var boxErrordanger = "Y_c5";
export var boxErrorinfo = "Y_c3";
export var boxErrorwarning = "Y_c4";